<script lang="ts">
	import { createEventDispatcher } from 'svelte';
	import { fly, fade } from 'svelte/transition';
	import type { TransitionConfig } from 'svelte/transition';

	export let hidden: boolean = true;
	export let activateClickOutside: boolean = true;
	export let backdrop: boolean = true;
	export let transitionType: 'fly' | 'fade' = 'fly';
	export let transitionParams: object = { x: -250, duration: 200 };
	export let width: string = 'w-80';
	export let divClass: string = '';
	export let id: string = 'drawer';
	let className: string = '';
	export { className as class };

	const dispatch = createEventDispatcher();

	function clickOutside(event: MouseEvent) {
		if (activateClickOutside && !hidden) {
			hidden = true;
			dispatch('clickOutside');
		}
	}

	function getTransition(type: string): (node: Element, params: object) => TransitionConfig {
		if (type === 'fly') return fly;
		return fade;
	}

	$: transition = getTransition(transitionType);
</script>

{#if backdrop && !hidden}
	<!-- svelte-ignore a11y-no-static-element-interactions -->
	<div
		on:click={clickOutside}
		on:keypress={() => {}}
		class="fixed inset-0 z-30 bg-gray-900/50"
		transition:fade={{ duration: 200 }}
	/>
{/if}

{#if !hidden}
	<div
		{id}
		class="fixed top-0 left-0 h-screen overflow-y-auto z-40 {width} {divClass} {className}"
		transition:fly={transitionParams}
	>
		<slot />
	</div>
{/if}
